export default function (user) {
  if (user != null) {
    if (user.type === "reviewer") {
      return [
        {
          title: "Inicial",
          to: "/overview",
          htmlBefore: '<i class="material-icons">dashboard</i>',
          htmlAfter: "",
        },
        {
          title: "Predicción",
          to: "/review",
          htmlBefore: '<i class="material-icons">edit</i>',
          htmlAfter: "",
        },
        {
          title: "Perfil",
          htmlBefore: '<i class="material-icons">person</i>',
          to: "/profile",
        },
      ];
    } else if (user.privileges === "admin") {
      return [
        {
          title: "Inicial",
          to: "/overview",
          htmlBefore: '<i class="material-icons">dashboard</i>',
          htmlAfter: "",
        },
        {
          title: "Nueva Lonja",
          htmlBefore: '<i class="material-icons">edit</i>',
          to: "/new-historic",
        },
        {
          title: "Nueva Mesa",
          htmlBefore: '<i class="material-icons">grid_on</i>',
          to: "/new-bovine-price",
        },
        {
          title: "Panel de admin",
          htmlBefore: '<i class="material-icons">assignment_turned_in</i>',
          to: "/admin-panel",
        },
        {
          title: "Nuevo usuario",
          htmlBefore: '<i class="material-icons">assignment_ind</i>',
          to: "/register",
        },
        {
          title: "Perfil",
          htmlBefore: '<i class="material-icons">person</i>',
          to: "/profile",
        },
      ];
    } else if (user.privileges === "reviewer") {
      return [
        {
          title: "Inicial",
          to: "/overview",
          htmlBefore: '<i class="material-icons">dashboard</i>',
          htmlAfter: "",
        },
        {
          title: "Predicción",
          to: "/review",
          htmlBefore: '<i class="material-icons">edit</i>',
          htmlAfter: "",
        },
        {
          title: "Perfil",
          htmlBefore: '<i class="material-icons">person</i>',
          to: "/profile",
        },
      ];
    } else {
      return [
        {
          title: "Inicial",
          to: "/overview",
          htmlBefore: '<i class="material-icons">dashboard</i>',
          htmlAfter: "",
        },
        {
          title: "Perfil",
          htmlBefore: '<i class="material-icons">person</i>',
          to: "/profile",
        },
      ];
    }
  } else {
    return [
      {
        title: "Inicial",
        to: "/overview",
        htmlBefore: '<i class="material-icons">dashboard</i>',
        htmlAfter: "",
      },
    ];
  }
}
